import React from 'react';
import cn from 'classnames';
import { isEmpty } from 'ava-util/dist/data';
import { IFeatureBlog } from 'mod/feature/interface';
import Image from '@base/lib/ThemeImage';
import ModuleTitle from '@base/lib/ModuleTitle';
import titleStyles from 'app/styles/modules/title.module.less';
import homeStyles from '@app/shop/index.module.less';
import styles from './index.module.less';
import Link from '@base/lib/ThemeLink';
import { getFeatureBlogTrackData, getModuleCode, getModuleElementId, getWrapStyle } from 'base/utils/features';
import Tracker from '@base/lib/Tracker';

declare interface IProps {
    data: IFeatureBlog;
}

const BlogList: React.FC<IProps> = ({ data }) => {
    const moduleCode = getModuleCode(data);
    const moduleElementId = getModuleElementId(data);

    return isEmpty(data.lists) ? null : (
        <div
            id={moduleElementId}
            data-t-mod={moduleCode}
            className={homeStyles.wrapper}
            style={getWrapStyle(data)}
        >
            <ModuleTitle
                className={cn(titleStyles.title, homeStyles.title)}
                text={data.title}
                link={data.readMoreLink}
                linkText={data.readMoreTitle}
                moduleCode={moduleCode}
            />

            <div className={styles.list}>
                {data.lists.slice(0, 4).map((item, index) => (
                    <Tracker key={index} data={getFeatureBlogTrackData(moduleCode, data, index)}>
                        <div className={styles.item}>
                            <Link href={item.linkUrl}>
                                <a className={styles['item-in']}>
                                    <Image
                                        src={item.picUrl}
                                        alt={item.altText || item.desc}
                                        width={355}
                                        height={200}
                                        className={styles.picture}
                                    />
                                    <div className={styles.info}>
                                        <div className={styles.desc}>{item.desc}</div>
                                        <div className={styles.tags}>
                                            {item.tags.map(tag => <span key={tag} className={styles.tag}>#{tag}</span>)}
                                        </div>
                                    </div>
                                </a>
                            </Link>
                        </div>
                    </Tracker>
                ))}
            </div>
        </div>
    )
}

export default React.memo(BlogList);
